import angular from 'angular';
import { forEach, size, uniq, merge, get, flatten, some, map, filter } from 'lodash';
import '../app.constants';
import '../services/globals';
import '../services/line';
import '../services/area';
import '../services/user';
import '../services/errors';
import '../services/place';
import '../services/redirect-to-new-version';
import '../services/group';
import '../components/carousel';
import '../services/organization';
import { localStorage } from '../utils';

const module = angular.module('whyline.controllers.now-serving', [
  'whyline.constants',
  'whyline.services.globals',
  'whyline.services.line',
  'whyline.services.area',
  'whyline.services.user',
  'whyline.services.errors',
  'whyline.services.place',
  'whyline.services.redirect-to-new-version',
  'whyline.services.group',
  'whyline.components.carousel',
  'whyline.services.organization',
]);

const NowServingController = (
  SAFE_STATES,
  $state,
  $rootScope,
  $scope,
  $timeout,
  ErrorService,
  PlaceService,
  GlobalsService,
  AreaService,
  LineService,
  UserService,
  GroupService,
  RedirectToNewVersionService,
  OrganizationService,
) => {
  /* @ngInject */

  const place = PlaceService.GetCurrent();
  const currentUser = UserService.GetCurrent();

  if (place.revertMigration) {
    RedirectToNewVersionService.Redirect('now-serving', place._id, currentUser._id, '');
  }

  // Initialization
  $scope.lines = {};
  $scope.areas = {};
  $scope.groups = {};
  $scope.thereAreQueues = true;

  setTimeout(() => {
    // Save the promises
    const useGroups = get(OrganizationService.GetCurrent(), 'configuration.queuer.useGroups', false);
    const getLines = LineService.GetMyLinesAsPromiseFromServer();
    const getAreas = AreaService.GetMyAreasAsPromiseFromServer();
    const getGroups = useGroups
      ? GroupService.GetAllForNowServing()
      : new Promise((resolve) => resolve([]));

    // Execute all the promises that we have
    // to get the lines and the areas for the current place
    
    Promise.all([getLines, getAreas, getGroups])
      .then(([lines, areas, groups]) => {
        // Save each response in each variable
        $timeout(() => {

          const groupsLines = uniq(map(flatten(map(groups, 'lines')), '_id'));
          const groupsAreas = uniq(map(flatten(map(groups, 'lines')), '_id'));

          const filteredLines = filter(lines, ({ _id }) => !groupsLines.includes(_id));
          const filteredAreas = filter(areas, ({ _id }) => !groupsAreas.includes(_id));
          $scope.lines = filteredLines;
          $scope.areas = filteredAreas;
          $scope.groups = groups;

          checkThereAreQueues();
        });
      })
      .catch(ErrorService.handler);
  }, 1000);

  const checkThereAreQueues = () => {
    if (size($scope.lines) || size($scope.areas)) {
      $scope.thereAreQueues = true;
    }
  };
};

module.exports = module.controller('NowServingController', NowServingController);
